<script setup lang="ts">
import { HEADER } from '@/services/consts/gps_tracker_settings';

function headerContentClass(index: number) {
  if (index == 0) {
    return 'ml-2'
  }
  return ''
}
</script>
<template>
  <thead>
    <tr>
      <th
        v-for="(item, index) in HEADER"
        :key="index"
        class="table-header column-space id-column"
      >
        <div :class="headerContentClass(index)">
          {{ item }}
        </div>
      </th>
    </tr>
  </thead>
</template>
